module.exports = __webpack_public_path__ + "img/yellow-dots.fc1df62.svg";